import React, { Component } from 'react';
import { Modal, Button, Input, Icon, DatePicker, message, InputNumber, Spin, Select, Tooltip, Cascader } from 'antd';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import { getMatchOption } from '../shared/selectFn';
import autoEval from '../shared/autoEvaluation';
import format from '../shared/format';
import $ from '../../common/AjaxRequest';
import UserDetail from './UserDetail';
import API_URL from '../../common/url';
import moment from 'moment';
import './css/list.less';
import SearchMulSelect from '../common/SearchMulSelect.js';

const Option = Select.Option;
const dateFormat = "YYYY-MM-DD";
const { TextArea } = Input;
const DefaultList = [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
];
const GlobalTypeList = [
    { label: '全球多中心', value: 'Global_Multicenter' },
    { label: '国内多中心', value: 'Internal_Multicenter' },
    { label: '国内单中心管理(区域负责)', value: 'Internal_Single' },
    { label: '不适用', value: 'Not_Applicable' },
];
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]
const SecondLineSimple = {
    '启动后常规CRC执行': '启动后',
    '可行性调研': '调研',
    '可行性调研': '调研',
    '启动前协助+启动后常规CRC执行': '启动前+启动后',
};
const Tip = (
    <Tooltip overlayClassName="downloadSite" placement="top" title="已启动中心数/津石计划负责中心数量">
        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
    </Tooltip>
);
let roleAuth = {};
const getRoleAuth = (curRole, editable_medicine = false) => {
    return {
        editable: curRole === 'BO' || curRole === 'CTA' || curRole === 'PML',
        editable_lineOfBusiness: curRole === 'BO' || curRole === 'CTA',
        editable_medicine
    };
};
//研究周期明细项（渲染与保存校验共用）
const CycleList = [
    { label: '准备期', key: 'preparePeriod' },
    { label: '入组期', key: 'joinGroupPeriod' },
    { label: '治疗期', key: 'treatmentPeriod' },
    { label: '随访期', key: 'followUpPeriod' },
    { label: '生存随访期', key: 'survivalFollowUpPeriod' },
    { label: 'DBL', key: 'dbl' },
    { label: '关中心', key: 'closeSite' },
];

class ViewInfoProcess extends Component {
    state = {
        visible: false,
        editable: false,
        loading: false,
        investigationId: '',
        processLoading: false,
        areaList: [],
        levelList: [],
        stageList: [],
        businessList: [],
        testeeTypeList: [],
        byStageList: [],
        otherCompanyList: [],
        treatmentMethodList: [],
        administrationModeList: [],
        TargetPointsOptions:[],
        disease: {},
        saveParams: {},
        processData: {},
        investigation: {},
        invPauseInfo:[],
        invPauseReason:[],
        canEditContractSitePlanAmount: false,
        canEditContractRandomPlanAmount: false,
        isOngoingProject: false, //是否是进行中的项目
        dictLoading: false,
        researchCycleModalVisible: false, //研究周期明细弹框
        researchCycleEditable: false, //研究周期明细弹框编辑态
        researchCycleSaving: false, //研究周期明细保存中
        evaluateCycleParams: {}, //研究周期明细编辑参数
        evaluateCodeOptions: [], //临床评估单号键入检索候选列表
    }

    hasSelectedBlindInv = false
    dictLoaded = false
    dictPendingCount = 0
    dictLoadTimer = null

    componentDidMount() {
        const { isModal, investigationId } = this.props;
        if (!isModal) {
            const { invId, positionRole, curRole } = sessionStorage;
            roleAuth = getRoleAuth(positionRole, curRole === 'PA' || curRole === 'PM');
            this.setState({
                investigationId: investigationId || invId,
            }, () => {
                this.loadData();
                this.queryInvestigationSecondLines(this.state.investigationId);
                this.queryInvestigationStageByInvId(this.state.investigationId);
            });
            this.loadDictData();
        }
        // isModal=true 时字典延迟到首次 show() 加载，避免列表页挂载即预载 7 个接口
    }

    // 字典与项目无关，首开一次；任一请求失败则完成数不满足，重开弹窗自动重试
    loadDictData = () => {
        this.dictPendingCount = 7;
        this.setState({ dictLoading: true });
        // 兜底：请求失败时 doneResult 不执行、loading 不会自然结束，15s 后强制结束（下拉为空，重开可重试）
        clearTimeout(this.dictLoadTimer);
        this.dictLoadTimer = setTimeout(() => {
            this.setState({ dictLoading: false });
        }, 15000);
        this.loadTypeConfigureList();
        this.queryWithLevelByParams();
        this.queryInvPauseInfo()
        this.queryInvPauseReason()
        this.queryByParams(
            // { key: 'Treatment_Method', name: 'treatmentMethodList' },
            { key: 'Administration_Mode', name: 'administrationModeList' }
        );
        this.getOtherPartnerCompanyAll();
        this.queryTumorTreatMethodList();
    }

    dictLoadedOne = () => {
        this.dictPendingCount -= 1;
        if (this.dictPendingCount <= 0) {
            this.dictLoaded = true;
            clearTimeout(this.dictLoadTimer);
            this.setState({ dictLoading: false });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.dictLoadTimer);
    }

    show = investigationId => {
        this.hasSelectedBlindInv = false;
        roleAuth = getRoleAuth(sessionStorage.curRole);
        if (!this.dictLoaded) {
            this.loadDictData();
        }
        this.setState({
            visible: true,
            saveParams: {},
            investigationId,
        }, () => {
            // this.loadData();
            this.queryInvestigationSecondLines(investigationId);
            this.queryInvestigationStageByInvId(investigationId);
        });
    }

    queryInvestigationSecondLines = (investigationId) => {
        //判断执行业务线二级分类
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId: investigationId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const contractSitePlanAmountSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const contractRandomPlanAmountSecondLines = ['启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const canEditContractSitePlanAmount = contractSitePlanAmountSecondLines.includes(secondLines);
                const canEditContractRandomPlanAmount = contractRandomPlanAmountSecondLines.includes(secondLines);
                this.setState({
                    canEditContractSitePlanAmount,
                    canEditContractRandomPlanAmount,
                });
            }
        };
        $.sendRequest(options);
    }

    // 获取项目阶段
    queryInvestigationStageByInvId = (investigationId) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const isOngoingProject = (data || []).some(el => el.typeValue == '准备期' || el.typeValue == '筛选入组期' || el.typeValue == '治疗随访期' || el.typeValue == '治疗结束随访期');
                this.setState({
                    isOngoingProject,
                },() => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    queryTumorTreatMethodList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryTumorTreatMethodList,
            data: { limit: 9999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({ treatmentMethodList: res.datas });
                this.dictLoadedOne();
            }
        };
        $.sendRequest(options);
    }

    queryMaxRandomDate = ()=>{
        const { investigationId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryMaxRandomDate,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                this.setState({MaxRandomDate:res.data})
            },
            errorResult: (err) => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    cancel = () => {
        this.setState({
            editable: false,
            visible: false,
            processData: {},
            investigation: {},
        }, () => {
            const { isModal } = this.props;
            !isModal && this.loadData();
        });
    }

    handleEdit = () => {
        this.setState({
            editable: true,
            evaluateCodeOptions: [],
        });
    }

    // 临床评估单号 键入检索，防抖请求候选列表
    handleEvaluateCodeChange = (value) => {
        const { saveParams } = this.state;
        saveParams.evaluateCode = value;
        this.setState({ saveParams });
        this.loadEvaluateCodeOptions(value);
    }

    // 选中(聚焦)即查询候选列表，不必先键入字符；keyword 为空时后端返回前20条
    loadEvaluateCodeOptions = (value) => {
        clearTimeout(this.evaluateCodeSearchTimer);
        this.evaluateCodeSearchTimer = setTimeout(() => {
            const options = {
                method: 'POST',
                url: API_URL.contract.queryEvaluateCodeList,
                data: { evaluateCode: value },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ evaluateCodeOptions: res.list || [] });
                },
            };
            $.sendRequest(options);
        }, 300);
    }

    loadData = () => {
        this.loadInvData();
        this.loadProcessData();
        this.queryMaxRandomDate()
    }

    canEditByInvStatus = () => {
        const { investigationId } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                        message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        this.handleEdit();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadInvData = () => {
        const { investigationId, isOngoingProject } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.view,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { investigation, investigationContractAmountStr ,invAutoChange } = res.data;
                const {
                    baUserList,
                    bdUserList,
                    pmUserList,
                    paUserList,
                    pmaList,
                    progressInfo,
                    planList,
                    stageIds,
                    investigationGlobalType,
                    investigationByStageId,
                    investigationSitePlan,
                    treatmentMethod,
                    administrationMode,
                    testeeTypeId,
                    lineOfBusiness,
                    isAgainstInvestigation,
                    typeName,
                    otherPartnerCompanyList,
                    beforeStartInvId,
                    investigationIdentifyCode,
                    investigationIdentifyCodeId,
                    researchProductTypeShow,
                    keyAccountManager,
                    investigationMedicineType: oldMedicineType,
                    secondResearchProductType,
                    targetList,
                    ...saveParams
                } = investigation;
                const planAmountMap = {
                    'Type_Site': 'contractSitePlanAmount',
                    'Type_Informed': 'contractInformedPlanAmount',
                    'Type_Filter': 'contractFilterPlanAmount',
                    'Type_Random': 'contractRandomPlanAmount',
                };
                (planList || []).forEach(item => {
                    //"合同计划中心数量"与"津石计划负责中心数量"、
                    //"合同计划知情数量"与"津石计划知情数量"、
                    //"合同计划筛选数量"与"津石计划筛选数量"、
                    //"合同计划随机(入组)数量"与"津石计划随机(入组)数量"、
                    // 如果合同计划的4个字段/津石计划的4个字段任意值为空，那么取向对应的字段
                    const contractAmountKey = planAmountMap[item.investigationPlanType];
                    const contractAmount = investigation[contractAmountKey];
                    if (isOngoingProject) {
                        item.planAmount = (item.planAmount === null || item.planAmount === undefined) 
                        ? contractAmount 
                        : item.planAmount;

                        saveParams[contractAmountKey] = (investigation[contractAmountKey] === null || investigation[contractAmountKey] === undefined) 
                        ? item.planAmount 
                        : investigation[contractAmountKey];
                    }

                    saveParams[`params[${item.investigationPlanType}]`] = item.planAmount;
                });   
                saveParams.targetIds = (targetList || []).map(i => ({ key: String(i.targetId), label: i.targetName }));
                saveParams.investigationMedicineType = secondResearchProductType ? [oldMedicineType, secondResearchProductType] : [oldMedicineType];
                saveParams.researchProductTypeShow = researchProductTypeShow;
                saveParams.investigationIdentifyCode = investigationIdentifyCode;
                saveParams.investigationIdentifyCodeId = investigationIdentifyCodeId;
                saveParams.stageIds = stageIds ? stageIds.split(',') : [];
                saveParams.investigationByStageId = investigationByStageId ? `${investigationByStageId}`.split(',') : [];
                saveParams.investigationGlobalType = investigationGlobalType || undefined;
                saveParams.siteAmount = investigationSitePlan;
                saveParams.treatmentMethod = treatmentMethod || undefined;
                saveParams.administrationMode = administrationMode || undefined;
                saveParams.testeeTypeId = testeeTypeId || undefined;
                saveParams.lineOfBusiness = lineOfBusiness || undefined;
                saveParams.investigationTypeName = typeName;
                saveParams.investigationContractAmountStr = investigationContractAmountStr;
                saveParams.isAgainstInvestigation = isAgainstInvestigation ? Number(isAgainstInvestigation) : undefined;
                saveParams.canEditBeforeStartInvName = beforeStartInvId? true :false;
                saveParams.keyAccountManagerId = (keyAccountManager || {}).userId;
                saveParams.keyAccountManagerName = (keyAccountManager || {}).userName;
                if(invAutoChange){
                    saveParams.autoChangeType = invAutoChange.autoChangeType || undefined;
                    saveParams.investigationActualLockDate = invAutoChange.investigationActualLockDate || undefined;
                    saveParams.investigationPlanLockDate = invAutoChange.investigationPlanLockDate || undefined;
                    if(invAutoChange.autoChangeType =='IN_PAUSE'){
                        saveParams.investigationPauseInfo = invAutoChange.investigationPauseInfo || undefined;
                        saveParams.investigationPauseInfoId = invAutoChange.investigationPauseInfoId || undefined;
                        saveParams.investigationPauseReason = invAutoChange.investigationPauseReason || undefined;
                        saveParams.investigationPauseReasonId = invAutoChange.investigationPauseReasonId || undefined;
                        saveParams.investigationPauseReasonRemark = invAutoChange.investigationPauseReasonRemark || undefined;
                        saveParams.investigationEstimatedRecoveryDate = invAutoChange.investigationEstimatedRecoveryDate?moment(invAutoChange.investigationEstimatedRecoveryDate).format(dateFormat) : undefined;
                    }
                    if(invAutoChange.autoChangeType =='NON_PAUSE'){
                        saveParams.investigationPauseCycle = invAutoChange.investigationPauseCycle==null?null : invAutoChange.investigationPauseCycle;
                        saveParams.investigationPauseDate = invAutoChange.investigationPauseDate?moment(invAutoChange.investigationPauseDate).format(dateFormat): undefined;
                        saveParams.investigationActualRecoveryDate = invAutoChange.investigationActualRecoveryDate?moment(invAutoChange.investigationActualRecoveryDate).format(dateFormat) : undefined;
                    }
                }
                saveParams.otherPartnerCompanyList = (otherPartnerCompanyList || []).map(i => {
                    return {
                        id: i.otherPartnerCompanyId + '',
                        name: i.otherPartnerCompanyName,
                        value: i.otherPartnerRelation.otherPartnerRelationName,
                        relationId: i.otherPartnerRelation.otherPartnerRelationId,
                    };
                });
                this.setState({
                    saveParams,
                    investigation,
                    loading: false,
                }, () => {
                    this.loadInvestigationByStageList();
                    this.querySponsor();
                    setTimeout(() => {
                        this.queryAllDiseaseList();
                    }, 100);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadProcessData = () => {
        const { investigationId } = this.state;
        this.setState({ processLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationProgress,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    processData: data,
                    processLoading: false,
                });
            },
            errorResult: () => {
                this.setState({ processLoading: false });
            }
        };
        $.sendRequest(options);
    }

    querySponsor = () => {
        const { saveParams } = this.state;
        const { contractSignCompanyName } = saveParams;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryCustomerCompanyByName,
            data: { customerCompanyName: contractSignCompanyName },
            dataType: 'json',
            doneResult: res => {
                const [option = {}] = res.data;
                option.value = option.customerCompanyId;
                option.text = option.customerCompanyName;
                this.setState({
                    saveParams
                },()=>{
                    this.handleChange(option, 'contractSignCompany');
                });
            }
        };
        $.sendRequest(options);
    }

    queryByParams = (...rest) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const params = {};
                res.typeConfigureList.forEach(i => {
                    const { name } = rest.find(r => r.key === i.typeName) || {};
                    if (name) {
                        if (!params[name]) {
                            params[name] = [];
                        }
                        params[name].push(i);
                    }
                });
                this.setState(params);
                this.dictLoadedOne();
            }
        };
        $.sendRequest(options);
    }

    queryInvPauseInfo = (...rest) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {typeName:'INVESTIGATION_PAUSE_INFO'},
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } =res
                this.setState({invPauseInfo:typeConfigureList})
                this.dictLoadedOne();
            }
        };
        $.sendRequest(options);
    }

    queryInvPauseReason = (...rest) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {typeName:'INVESTIGATION_PAUSE_REASON'},
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } =res
                this.setState({invPauseReason:typeConfigureList})
                this.dictLoadedOne();
            }
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    areaList: res.areaList,
                    levelList: res.levelList,
                    typeList: res.typeList,
                    stageList: res.stageList,
                    testeeTypeList: res.testeeTypeList,
                    contractTypeList: res.contractTypeList,
                });
                this.dictLoadedOne();
            }
        }
        $.sendRequest(options)
    }

    loadInvestigationByStageList = () => {
        const { investigationMedicineType,  blindInvestigationId } = this.state.saveParams;
        if (!investigationMedicineType || (investigationMedicineType && investigationMedicineType.length == 0)) {
            this.setState({ byStageList: [] });
        } else {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType: investigationMedicineType[0] },
                dataType: 'json',
                doneResult: data => {
                    this.setState({ byStageList: data.data }, () => {
                        if (!blindInvestigationId) {
                            this.autoEvaluation();
                        }
                    });
                }
            };
            $.sendRequest(options);
        }
    }

    queryWithLevelByParams = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryWithLevelByParams,
            data: { typeName: 'LINE_OF_BUSINESS' },
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } = res;
                this.setState({ businessList: typeConfigureList || [] });
                this.dictLoadedOne();
            },
        };
        $.sendRequest(options);
    }

    queryAllDiseaseList = () => {
        const { saveParams: { diseaseName, diseaseId } } = this.state;
        if (diseaseName) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryAllDiseaseList,
                data: { keyword: diseaseName },
                dataType: 'json',
                doneResult: res => {
                    const disease = getMatchOption(res.data, 'diseaseId', diseaseId);
                    this.setState({ disease }, () => {
                        this.autoEvaluation();
                    });
                },
            };
            $.sendRequest(options);
        } else {
            this.setState({ disease: {} });
        }
    }

    getOtherPartnerCompanyAll = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.getOtherPartnerCompanyAll,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ otherCompanyList: res.otherPartnerCompanyAll });
                this.dictLoadedOne();
            },
        };
        $.sendRequest(options);
    }

    handleConfirmation = (value, key) => {
        if(value.investigationName){
            const config = {
                beforeStartInv:{
                    title:'配套启动前项目',
                },
                blindInvestigation:{
                    title:'配套盲态项目',
                },
            }
            const _this = this;
            Modal.confirm({
                    title: `${config[key].title}配置确认`,
                    content: `${config[key].title}：${value.investigationName}，请确认`,
                    onOk() {
                        _this.handleChange(value, key)
                    },
                });
        }else {
            this.handleChange(value, key)
        }
        
    }

    handleChange = (value, key) => {
        const { saveParams } = this.state;
        switch (key) {
            case 'identifyCode': {
                const { value: id, text: name } = value;
                saveParams.investigationIdentifyCodeId = id;
                saveParams.investigationIdentifyCode = name;
                this.setState({ saveParams });
                break;
            }
            case 'stageIds': {
                const { levelList, stageList } = this.state;
                let newValue = (value || []).slice();
                if (newValue.length >= 2) {
                    let lastValue;
                    const { groupId: fg } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                    const { groupId: lg } = getMatchOption(stageList, 'typeConfigureId', (lastValue = newValue.slice(-1))[0]);
                    if (fg !== lg) {
                        newValue = lastValue;
                    }
                }

                const { typeValue } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                if (typeValue === '治疗结束随访期' || typeValue === '项目暂停') {
                    const { levelId } = saveParams;
                    const { typeValue: level } = getMatchOption(levelList, 'typeConfigureId', levelId);
                    if (level && level !== 'C') {
                        saveParams.levelId = levelId + 1;
                    }
                }
                if(typeValue === '项目暂停'){
                    saveParams.isFinishInGroup = 1;
                    saveParams.autoChangeType='IN_PAUSE'//项目暂停
                    saveParams.investigationPauseDate = null;
                    saveParams.investigationActualRecoveryDate = null;
                    saveParams.investigationPauseCycle = null;
                    saveParams.actualFinishInGroupTimeShow = saveParams.actualFinishInGroupTimeShow ?  moment(saveParams.actualFinishInGroupTimeShow).format('YYYY-MM-DD') : null
                }
                if(typeValue !== '项目暂停' && (saveParams.stageNameShowX || '').substring(0,4) =='项目暂停'){
                    saveParams.autoChangeType = 'NON_PAUSE';//项目取消暂停
                    saveParams.investigationPauseDate = saveParams.suspendTime?moment(saveParams.suspendTime).format(dateFormat):null;
                    saveParams.investigationActualRecoveryDate = moment().format(dateFormat);
                    saveParams.investigationPauseCycle = saveParams.investigationPauseDate?moment(saveParams.investigationActualRecoveryDate,dateFormat).diff(saveParams.investigationPauseDate, 'days'):null;
                    if(saveParams.investigationPauseCycle && saveParams.investigationPauseCycle<0){
                        message.error('项目实际恢复日期必须大于或等于项目暂停时间,否则无法保存！');
                        saveParams.investigationPauseCycle = Math.round((saveParams.investigationPauseCycle/30))
                    }else if(saveParams.investigationPauseCycle){
                        saveParams.investigationPauseCycle = Math.round((saveParams.investigationPauseCycle/30))
                    }
                    saveParams.investigationPauseInfoId = null;
                    saveParams.investigationPauseInfo = null;
                    saveParams.investigationPauseReasonId = null;
                    saveParams.investigationPauseReason = null;
                    saveParams.investigationPauseReasonRemark = null;
                    saveParams.investigationEstimatedRecoveryDate = null;
                    saveParams.suspendTime = null;
                }
                if( typeValue === '数据清理期'){
                    saveParams.autoChangeType=''
                    saveParams.investigationActualLockDate = null;
                }else if((saveParams.stageNameShowX || '').split(',').some(el => { return el === '数据清理期'})){
                    if(typeValue !== '项目暂停'){
                        saveParams.autoChangeType='LOCK_DATA'//锁库
                    }
                    saveParams.investigationActualLockDate = moment().format(dateFormat)
                }
                    
                if(saveParams.stageNameShow == '项目暂停') // bug 32479
                {
                    if(typeValue === '准备期' || typeValue === '筛选入组期')
                    {
                        saveParams.isFinishInGroup = 0;
                        saveParams.actualFinishInGroupTimeShow = undefined;
                    }
                }
                if(typeValue === '项目暂停' || typeValue === '项目终止' || typeValue === '合同请款完成，合同结束'){
                    const rules = (saveParams.lineOfBusinessString == '肿瘤' || saveParams.lineOfBusinessString == '非肿瘤' || saveParams.lineOfBusinessString == '综合') && ( saveParams.secondLineNames !== '启动前协助+启动后常规CRC执行' && saveParams.secondLineNames !== '启动后常规CRC执行');
                    if(rules){
                        const {MaxRandomDate} = this.state
                        saveParams.isFinishInGroup = 1;
                        saveParams.actualFinishInGroupTimeShow = MaxRandomDate || undefined;
                    }
                }
                saveParams.stageIds = newValue;
                this.setState({ saveParams });
                break;
            }
            case 'investigationGlobalType': {
                saveParams[key] = value;
                if (value == 'Internal_Single') {
                    saveParams.levelId = 3;
                } else {
                    saveParams.levelId = 2;
                }
                this.setState({ saveParams });
                break;
            }
            //项目暂停时间
            case 'suspendTime':
                {
                    const { saveParams:{stageIds} } = this.state;
                    saveParams[key] = value;
                    const rules = (saveParams.lineOfBusinessString == '肿瘤' || saveParams.lineOfBusinessString == '非肿瘤' || saveParams.lineOfBusinessString == '综合') && ( saveParams.secondLineNames !== '启动前协助+启动后常规CRC执行' && saveParams.secondLineNames !== '启动后常规CRC执行');
                    if(stageIds.some(e=>{return e ==='26'}) && !rules){
                        saveParams.actualFinishInGroupTimeShow = saveParams.actualFinishInGroupTimeShow ?  moment(saveParams.actualFinishInGroupTimeShow).format('YYYY-MM-DD') : moment(value).format('YYYY-MM-DD')
                    }
                    this.setState({ saveParams });
                }
            case 'isClinicalProject':
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.handleChange(undefined, 'lineOfBusiness');
                });
                break;
            case 'investigationMedicineType':
                Object.assign(saveParams, {
                    treatmentMethod: undefined,
                    drugMainTargets: undefined,
                    administrationMode: undefined,
                    administrationModeRemark: undefined,
                    investigationMedicine: undefined,
                    investigationByStageId: undefined,
                    investigationByStageRemark: undefined,
                    investigationMedicineType: value,
                });
                saveParams.treatmentMethod = this.changeTreatMethod(value);
                this.setState({ saveParams }, () => {
                    this.loadInvestigationByStageList();
                });
                break;
            case 'administrationMode':
                saveParams[key] = value;
                saveParams.administrationModeRemark = undefined;
                this.setState({ saveParams });
                break;
            case 'investigationByStageId': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || []).slice(-1));
                saveParams.investigationByStageRemark = undefined;
                saveParams.investigationByStageId = isMultipleChoice == 1 ? value : investigationByStageId ? [String(investigationByStageId)] : [];
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'testeeTypeId': {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'disease': {
                const { value: diseaseId, text: diseaseName, diseaseClassName, investigationAreaId, investigationAreaName, invAreaGroupType } = value;
                saveParams.diseaseId = diseaseId;
                saveParams.diseaseName = diseaseName ? diseaseName.replace(/^(NA)\(.+\)$/, '$1') : undefined;
                saveParams.diseaseClassName = diseaseClassName;
                saveParams.investigationAreaId = investigationAreaId;
                saveParams.investigationAreaName = investigationAreaName;
                saveParams.invAreaGroupType = invAreaGroupType;
                this.setState({
                    saveParams,
                    disease: value,
                }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'lineOfBusiness': {
                const { businessList } = this.state;
                const { typeConfigureId, typeValue } = getMatchOption(businessList, 'typeConfigureId', value);
                saveParams.lineOfBusiness = typeConfigureId ? typeConfigureId.toString() : undefined;
                saveParams.lineOfBusinessString = typeValue;
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'contractSignCompany': {
                const { value: id, text: name, customerCompanySpecialName } = value;
                saveParams.contractSignCompanyName = name;
                saveParams.contractSignCompanyId = id;
                saveParams.customerCompanySpecialName = customerCompanySpecialName;
                this.setState({ saveParams });
                break;
            }
            case 'sponsor': {
                const { value: id, text: name, customerCompanySpecialName } = value;
                saveParams.investigationSponsor = name;
                saveParams.investigationSponsorId = id;
                // saveParams.customerCompanySpecialName = customerCompanySpecialName;
                this.setState({ saveParams });
                break;
            }
            case 'cro': {
                const { value: id, text: name } = value;
                saveParams.cro = name;
                saveParams.croId = id;
                this.setState({ saveParams });
                break;
            }
            case 'bd': {
                const { value: id, text: name } = value;
                saveParams.bdUserId = id;
                saveParams.bdUserName = name;
                this.setState({ saveParams });
                break;
            }
            case 'otherPartnerCompanyList': {
                const { otherCompanyList } = this.state;
                const { otherPartnerCompanyList } = saveParams;
                (value || []).sort((a, b) => a - b);
                const newOtherPartnerCompanyList = (value || []).map(i => {
                    const option = otherPartnerCompanyList.find(o => o.id == i);
                    if (option) {
                        return option
                    } else {
                        const { otherPartnerCompanyId, otherPartnerCompanyName } = getMatchOption(otherCompanyList, 'otherPartnerCompanyId', i);
                        return { id: otherPartnerCompanyId + '', name: otherPartnerCompanyName };
                    }
                });
                saveParams.otherPartnerCompanyList = newOtherPartnerCompanyList;
                this.setState({ saveParams });
                break;
            }
            case 'blindInvestigation': {
                const {
                    value: id, text: name, investigationGlobalType, stageIds, investigationMedicineType: oldMedicineType,secondResearchProductType,
                    treatmentMethod, drugMainTargets, administrationMode, administrationModeRemark,
                    investigationMedicine, investigationByStageId, investigationByStageRemark, diseaseId,
                    diseaseName, diseaseClassName, investigationAreaId, investigationAreaName, testeeTypeId,
                    lineOfBusiness, lineOfBusinessString, investigationSponsor, investigationSponsorId, cro, croId,
                    investigationSponsorSpecial, contractSignCompanyId, contractSignCompanyName,
                } = value;
                const { businessList, saveParams } = this.state;
                const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
                const { typeConfigureId, typeValue } = getMatchOption(secondLineList, 'typeValue', '非盲');
                let newSaveParams;
                if (id) {
                    if (
                        !oldMedicineType ||
                        !investigationByStageId ||
                        !diseaseId ||
                        !testeeTypeId ||
                        !lineOfBusiness ||
                        !typeConfigureId
                    ) {
                        message.warning('关联的盲态项目项目信息不完整，请完善！');
                        return;
                    }
                    if (!saveParams.blindInvestigationId) {
                        this.prevState = {...saveParams};
                    }
                    newSaveParams = {
                        ...saveParams,
                        blindInvestigationId: id,
                        blindInvestigationName: name,
                        investigationGlobalType,
                        stageIds: stageIds ? stageIds.split(',') : [],
                        investigationMedicineType: secondResearchProductType ? [oldMedicineType, secondResearchProductType] : [oldMedicineType],
                        treatmentMethod,
                        drugMainTargets,
                        administrationMode,
                        administrationModeRemark,
                        investigationMedicine,
                        investigationByStageId: investigationByStageId ? investigationByStageId.split(',') : [],
                        investigationByStageRemark,
                        diseaseId,
                        diseaseName,
                        diseaseClassName,
                        investigationAreaId,
                        investigationAreaName,
                        testeeTypeId,
                        lineOfBusiness,
                        lineOfBusinessString,
                        secondLineIds: typeConfigureId,
                        secondLineNames: typeValue,
                        investigationSponsor,
                        investigationSponsorId,
                        contractSignCompanyId,
                        contractSignCompanyName,
                        customerCompanySpecialName: investigationSponsorSpecial,
                        cro,
                        croId,
                    };
                } else {
                    newSaveParams = {
                        ...saveParams,
                        blindInvestigationId: id,
                        blindInvestigationName: name,
                        ...(this.prevFields || {})
                    };
                    this.prevFields = {};
                }
                this.setState({ saveParams: newSaveParams }, () => {
                    this.loadInvestigationByStageList();
                });
                break;
            }
            case 'beforeStartInv':{
                const { value: id, text: name } = value;
                saveParams[`${key}Id`] = id;
                saveParams[`${key}Name`] = name;
                this.setState({saveParams});
                break;
            }
            case 'investigationPauseInfo':
            case 'investigationPauseReason':{
                if(key == 'investigationPauseReason' && value != 136){
                    saveParams.investigationPauseReasonRemark = null;
                }
                saveParams[`${key}Id`] = value;
                this.setState({saveParams});
                break;
            }
            case 'isFinishInGroup':{
                saveParams[key] = value;
                if(value === 0){
                    saveParams.actualFinishInGroupTimeShow = null
                }
                this.setState({ saveParams });
                break;
            }
            default:
                saveParams[key] = value;
                this.setState({ saveParams });
        }
    }

    handleOCCTextChange = (value, index) => {
        const { saveParams } = this.state;
        const { otherPartnerCompanyList } = saveParams;
        otherPartnerCompanyList[index].value = value;
        this.setState({ saveParams });
    }

    jointProjectName = () => {
        const { saveParams, investigation } = this.state;
        const { secondLineNames } = investigation;
        const { createType, investigationName, diseaseName, lineOfBusinessString, investigationCode, customerCompanySpecialName, 
            isClinicalProject //  是否是临床项目 1 是 0 否
         } = saveParams;
        if (createType !== 'JDE_CREATE') {
            return investigationName;
        } else {
            const showStr = (isClinicalProject == 0 || lineOfBusinessString == 'ARO') ?
            `${customerCompanySpecialName}-${diseaseName}-${investigationCode}（${lineOfBusinessString}）` 
            : `${customerCompanySpecialName}-${diseaseName}-${investigationCode}（${lineOfBusinessString}-${SecondLineSimple[secondLineNames] || secondLineNames}）`
            if (diseaseName && lineOfBusinessString && investigationCode && customerCompanySpecialName) {
                return showStr;
            }
        }
    }

    // 优先使用obj1的数据，其次obj2
    combineValue = (obj1, obj2, keys, params) => {
        keys.forEach(key => {
            params[key] = obj1[key] != undefined ? obj1[key] : obj2[key];
        });
        return params;
    }

    save = () => {
        const {
            investigationId,
            investigation,
            stageList,
            byStageList,
            administrationModeList,
            canEditContractSitePlanAmount,
            canEditContractRandomPlanAmount,
        } = this.state;
        const saveParams = {...this.state.saveParams};
        const {
            stageIds,
            createType,
            customerCompanySpecialName,
            otherPartnerCompanyList,
            isFinishInGroup,
            stageNameShowX,
            lineOfBusinessString,  //业务线
            secondLineNames,//业务线二级分类
            investigationNeedHeredity,
            investigationMedicineType = [],
            targetIds = [],
        } = saveParams;
        saveParams.investigationMedicineType = investigationMedicineType[0];
        saveParams.secondResearchProductType = investigationMedicineType[1];
        saveParams.targetIds = targetIds.map(el => el.key).join(',');
        const { planList, bdUserList } = investigation;
        const { invId, invState } = sessionStorage;

        const ProjectRange =['准备期','项目执行工作全部完成','项目暂停','项目待终止','项目终止','合同请款完成','合同结束'];
        //业务线为：肿瘤、综合、非肿瘤
        const rulesOfBusiness = lineOfBusinessString == '肿瘤' || lineOfBusinessString == '非肿瘤' || lineOfBusinessString == '综合';
        // 执行业务线二级分类为:非盲
        const rulesSecondLineIsBlind = secondLineNames == '非盲';
        // 执行业务线二级分类为:启动后常规CRC执行、启动前协助+启动后常规CRC执行、其他
        const rulesSecondLineIsStart = secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行' || secondLineNames == '其他'
        //执行业务线二级分类是:遗传办、SSU主导、启动前协助、可行性调研、质量培训、安全事务、小时卡
        const rulesSecondLineIsOther = secondLineNames == '遗传办' || secondLineNames == 'SSU主导' || secondLineNames == '启动前协助' || secondLineNames == '可行性调研' || secondLineNames == '质量培训' || secondLineNames == '安全事务' || secondLineNames == '小时卡';
        const isJdeCreate = createType === 'JDE_CREATE';
        const { typeValue: stageName } = getMatchOption(stageList, 'typeConfigureId', (stageIds || []).slice(-1).join());
        let newStageName ='' ;
        (stageIds || []).forEach((el,index)=>{
            if(index == stageIds.length-1){
                newStageName = newStageName+getMatchOption(stageList, 'typeConfigureId', el).typeValue
            }else{
                newStageName = newStageName+getMatchOption(stageList, 'typeConfigureId', el).typeValue+'、';
            }
        })
        const showAdministrationModeOther = getMatchOption(administrationModeList, 'typeConfigureId', saveParams.administrationMode).typeValue === '其他';
        const showByStageOther = getMatchOption(byStageList, 'investigationByStageId', saveParams.investigationByStageId).investigationByStageName === '其他';

        const params = {};
        const keys = [
            'investigationCode',
            'investigationGlobalType',
            'levelId',
            'stageIds',
            'investigationNeedHeredity',
            'investigationMedicineType',
            'investigationByStageId',
            'diseaseId',
            'testeeTypeId',
            'lineOfBusiness',
            'investigationSponsorId',
            'investigationPlanBeginTime',
            'investigationPlanEndTime',
            'contractSitePlanAmount',
            'contractFilterPlanAmount',
            'contractRandomPlanAmount',
            'params[Type_Site]',
            'params[Type_Filter]',
            'params[Type_Random]'
        ];
        this.combineValue(saveParams, investigation, keys, params);
        if (!investigationNeedHeredity && investigationNeedHeredity !== 0) {
            message.warning('请选择项目是否需要过遗传办!');
                return;
        }
        // if ((lineOfBusinessString == '肿瘤' || saveParams.lineOfBusiness == 44) && !saveParams.treatmentMethod) {
        //     message.warning('请选择肿瘤治疗方式');
        //     return;
        // }
        if (!saveParams.investigationGlobalType) {
            message.warning('请选择项目类型');
            return;
        }
        if (!saveParams.contractSignCompanyId) {
            message.warning('请选择合同签署方');
            return;
        }
        if (!saveParams.investigationSponsorId) {
            message.warning('请选择申办方');
            return;
        }
        if (!saveParams.contractSitePlanAmount && (saveParams.lineOfBusinessString === 'ARO' || saveParams.lineOfBusinessString === '招募' || canEditContractSitePlanAmount)) {
            message.warning('请选择合同计划中心数量');
            return;
        }
        if (!saveParams.contractRandomPlanAmount && (saveParams.lineOfBusinessString === 'ARO' || saveParams.lineOfBusinessString === '招募' || canEditContractRandomPlanAmount)) {
            message.warning('请选择合同计划随机(入组)数量');
            return;
        }
        if (saveParams.firstSiteStartTimeFlag && saveParams.firstSiteStartTimeUpdateFlag && !saveParams.firstSiteStartTime) {
            message.warning('请选择津石第一家研究中心启动计划开始时间');
            return;
        }
        if (saveParams.oneHundredPercentSiteStartTimeFlag && saveParams.oneHundredPercentSiteStartTimeUpdateFlag && !saveParams.oneHundredPercentSiteStartTime) {
            message.warning('请选择津石100%中心启动计划开始时间');
            return;
        }
        if (saveParams.firstPatientGroupStartTimeFlag && saveParams.firstPatientGroupStartTimeUpdateFlag && !saveParams.firstPatientGroupStartTime) {
            message.warning('请选择津石首例受试者随机（入组）计划开始时间');
            return;
        }
        if (saveParams.oneHundredPercentGroupStartTimeFlag && saveParams.oneHundredPercentGroupStartTimeUpdateFlag && !saveParams.oneHundredPercentGroupStartTime) {
            message.warning('请选择津石100%受试者随机（入组）计划开始时间');
            return;
        }
        if (!isJdeCreate) {
            this.combineValue(saveParams, investigation, ['investigationName'], params);
        }
        if (stageName === '项目暂停') {
            this.combineValue(saveParams, investigation, ['suspendTime'], params);
        }
        if (saveParams.investigationMedicineType == 'Research_drugs' && showAdministrationModeOther) {
            this.combineValue(saveParams, investigation, ['administrationModeRemark'], params);
        }
        if (showByStageOther) {
            this.combineValue(saveParams, investigation, ['investigationByStageRemark'], params);
        }
        // if (!saveParams['params[Type_Site]'] && saveParams['params[Type_Site]'] !== 0) {
        //     message.warning('请输入津石计划负责中心数量');
        //     return;
        // }

        if (isJdeCreate) {
            if (!(saveParams.investigationName = this.jointProjectName()) && !customerCompanySpecialName) {
                message.warning('申办方尚未维护客户简称，请联系后台管理员');
                return;
            }
            if (!saveParams.investigationName) {
                message.warning('项目名称未自动生成，请填写完整');
                return;
            }
        }

        if ((otherPartnerCompanyList || []).length) {
            otherPartnerCompanyList.forEach((item, index) => {
                params[`otherPartnerCompanyList[${index}].otherPartnerCompanyId`] = item.id;
                params[`otherPartnerCompanyList[${index}].otherPartnerRelation.otherPartnerRelationId`] = item.relationId;
                params[`otherPartnerCompanyList[${index}].otherPartnerRelation.otherPartnerRelationName`] = item.value;
            });
        }

        delete saveParams.otherPartnerCompanyList;

        const investigationParams = {};
        (planList || []).forEach(d => investigationParams[`params[${d.investigationPlanType}]`] = d.planAmount);

        if (!saveParams[`params[Type_Site]`] && saveParams[`params[Type_Site]`] != 0) {
            message.warning('请输入津石计划负责中心数量');
            return;
        }

        params.investigationId = invState == 3 ? invId : investigationId;
        params.bdUserId = (bdUserList || [])[0] ? bdUserList[0].userId : '';
        params.stageIds = (params.stageIds || []).join(",");
        params.suspendTime = format('date', params.suspendTime);
        params.investigationByStageId = (params.investigationByStageId && Array.isArray(params.investigationByStageId)) ? (params.investigationByStageId || []).join(',') : params.investigationByStageId;
        params.investigationPlanBeginTime = format('date', params.investigationPlanBeginTime);
        params.investigationPlanEndTime = format('date', params.investigationPlanEndTime);
        // if(!saveParams.investigationIdentifyCode){
        //     message.error('请选择项目识别码');
        //     return;
        // }
        const actualFinishInGroupTimeIsMust = isFinishInGroup == 1 && (lineOfBusinessString == '肿瘤' || lineOfBusinessString == '非肿瘤' || lineOfBusinessString == '综合') && ( secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行')
        if (actualFinishInGroupTimeIsMust && !saveParams.actualFinishInGroupTimeShow) {
            message.warning('请选择项目实际结束入组时间');
            return;
        }
        if(stageName && rulesOfBusiness && rulesSecondLineIsOther){
            if(!ProjectRange.some(e=>{return e == stageName})){
                message.error('项目阶段不满足要求，请重新选择');
                return;
            }
        }
        if(stageName == '项目暂停'){
            saveParams.autoChangeType = 'IN_PAUSE'//项目暂停
            if(!saveParams.suspendTime){
                message.error('请选择项目暂停时间');
                return;
            }
            if(!saveParams.investigationPauseInfoId){
                message.error('请选择项目暂停情况');
                return;
            }
            if(!saveParams.investigationPauseReasonId){
                message.error('请选择项目暂停原因');
                return;
            }
        }else if(stageNameShowX && stageNameShowX.substring(0,4) == '项目暂停'){
            saveParams.autoChangeType = 'NON_PAUSE'//项目取消暂停
            if(moment(saveParams.investigationActualRecoveryDate,dateFormat).diff(saveParams.investigationPauseDate, 'days')<0){
                message.error('项目实际恢复日期＜项目暂停日期，无法调整！');
                return;
            }
        }
        // stageId == 17 数据清理期
        if(saveParams.stageIds.some(el => { return el == '17'}) && !saveParams.investigationPlanLockDate){
            message.error('请选择计划锁库日期');
            return;
        }
        if(isFinishInGroup == 0 && !(saveParams.blindType == 'NOTBLIND') && (stageNameShowX == '准备期' ||  stageNameShowX == '筛选入组期')&&(stageName !== '准备期' &&  stageName !== '筛选入组期' &&  stageName !== '项目暂停')){
            const _this = this;
            Modal.confirm({
                title: (<span style={{color:'#000'}}>项目阶段变更确认</span>),
                content: (
                    <div>
                        <p style={{marginBottom:'10px'}}>{`项目阶段从“${stageNameShowX}”变更为“${newStageName}”，请确认项目是否结束入组？`}</p>
                        <p>一旦确认，“项目是否结束入组”显示为“是”</p>
                    </div>
                ),
                onOk() {
                    _this.handleChange(1, 'isFinishInGroup');
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }else if(isFinishInGroup == 1 && (stageName == '准备期' ||  stageName == '筛选入组期'))
        {
            const _this = this;
            Modal.confirm({
                title: '项目阶段变更确认',
                content: <div><p style={{ color: 'red' }}>注：项目阶段不可逆</p><p>项目已经完成入组，阶段将自动变更为“治疗随访期”，请确认</p></div>,
                onOk() {
                    _this.saveFunc({ ...investigationParams,...saveParams,...params});
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        } else {
            this.saveFunc({ ...investigationParams,...saveParams,...params});
        }
    }

    saveFunc =(params)=>{
        const { 
            firstSiteStartTime,
            oneHundredPercentSiteStartTime,
            firstPatientGroupStartTime,
            oneHundredPercentGroupStartTime,
            firstSiteStartTimeUpdateFlag,
            oneHundredPercentSiteStartTimeUpdateFlag,
            firstPatientGroupStartTimeUpdateFlag,
            oneHundredPercentGroupStartTimeUpdateFlag,
        } = params;
        const { isModal } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.updateInvestigation,
            data: {
                ...params,
                // 这四个字段无修改权限时，需要传空值
                firstSiteStartTime: firstSiteStartTimeUpdateFlag ? firstSiteStartTime : null,
                oneHundredPercentSiteStartTime: oneHundredPercentSiteStartTimeUpdateFlag ? oneHundredPercentSiteStartTime : null,
                firstPatientGroupStartTime: firstPatientGroupStartTimeUpdateFlag ? firstPatientGroupStartTime : null,
                oneHundredPercentGroupStartTime: oneHundredPercentGroupStartTimeUpdateFlag ? oneHundredPercentGroupStartTime : null,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('修改成功');
                this.setState({
                    editable: false,
                    visible: false,
                    loading: false,
                }, () => {
                    if (isModal) {
                        this.props.loadData();
                    } else {
                        this.loadData();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    showUserDetail = (userId) => {
        this.userDetailRef.show(userId);
    }

    getUserByWorkStatus = (list) => {
        const len = (list || []).length;
        const result = (list || []).map((d, i) => {
            const { userId, userName, workStatus } = d;
            return (
                workStatus == 'LEFT' ?
                    <span key={userId} style={{ color: '#ccc' }}>{userName}{(i < len - 1) && '；'}</span>
                    :
                    <span key={userId}>
                        <a onClick={() => this.showUserDetail(userId)}>{userName}</a>
                        {(i < len - 1) && '；'}
                    </span>
            );
        });
        return result;
    }

    getUser = (list, isLeaer = false) => {
        const len = (list || []).length;
        const result = (list || []).map((d, i) => {
            const { userId, leaderNameCode: userName, workStatus, isMain = null } = d;
            return (
                workStatus == 'LEFT' ?
                    <span key={userId} style={{ color: '#ccc' }}>{userName}{(i < len - 1) && '；'}</span>
                    :
                    <span key={userId}>
                        <a onClick={() => this.showUserDetail(userId)}>{`${userName}${isMain == '1' ? '（主）' : ''}`}</a>
                        {(i < len - 1) && '；'}
                    </span>
            );
        });
        return result;
    }

    getKeyAccountManager = (id, name) => {
        const result = <span key={id}>
            <a onClick={() => this.showUserDetail(id)}>{name}</a>
        </span>
        return result;
    }

    autoEvaluation = () => {
        const { typeList, businessList ,testeeTypeList, byStageList, saveParams, disease } = this.state;
        const {
            jdeApplySceneId, jdeApplyIsInvestigationExists, isClinicalProject, investigationMedicineType,
            investigationByStageId, investigationAreaName, testeeTypeId, investigationName, invAreaGroupType
        } = saveParams;

        const params = autoEval({
            type: 'CTA',
            businessList,
            byStageList,
            typeList,
            testeeTypeList,
            disease,
            isClinicalProject,
            investigationMedicineType,
            investigationByStageId,
            investigationAreaName,
            invAreaGroupType,
            testeeTypeId,
            jdeApplySceneId,
            jdeApplyIsInvestigationExists,
            investigationName,
        });
        this.setState({ saveParams: Object.assign(saveParams, params) });
    }

    changeTreatMethod = (value) => {
        const { treatmentMethodList } = this.state;
        let text,treat = undefined;
        switch (value[1]) {
            case 'Radiation_therapy':
                text = '放射疗法（ 同位素 核药；照射 ）'
                break;
            case 'Cell_therapy':
                text = '细胞治疗: CART'
                break;
            case 'Stem_cell_therapy':
                text = '干细胞治疗'
                break;
            case 'Gene_therapy':
                text = '基因治疗'
                break;
            default:
                break;
        };
        treatmentMethodList.map(el => {
            if (el.treatMethod == text) {
                treat = el.evaluateTumorTreatMethodId;
            }
        });
        return treat
    }

    parseTargetPointsData = res => {
        if ((res.datas)) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: item.targetName,
                value: String(item.evaluateTargetPointsId),
                fetching: false,
            }));
            this.setState({ TargetPointsOptions: data });
        } else {
            this.setState({ TargetPointsOptions: [] });
        }
    }

    targetPointsSelectChange = (value = []) => {
        const { saveParams } = this.state;
        saveParams.targetIds = value;
        this.setState({ saveParams });
    }

    disabledDate = (current) => {
        const { saveParams: {investigationPlanBeginTime, investigationPlanEndTime} } = this.state;
        const maxValue = moment(investigationPlanEndTime).valueOf();
        const minValue = moment(investigationPlanBeginTime).valueOf();
        return !(current && current.valueOf() >= minValue && current.valueOf() <= maxValue);
    };

    getContent = () => {
        const {
            editable,
            byStageList,
            levelList,
            stageList,
            businessList,
            testeeTypeList,
            otherCompanyList,
            treatmentMethodList,
            TargetPointsOptions,
            administrationModeList,
            saveParams,
            processData,
            investigation,
            invPauseInfo,
            invPauseReason,
            MaxRandomDate,
            canEditContractSitePlanAmount,
            canEditContractRandomPlanAmount,
            evaluateCodeOptions,
        } = this.state;
        const {
            investigationName,
            stageIds,
            isClinicalProject,
            investigationMedicineType = [],
            investigationByStageId,
            investigationByStageName,
            investigationByStageRemark,
            administrationMode,
            createType,
            otherPartnerCompanyList,
            canEditBeforeStartInvName,
            isFinishInGroup,
            lineOfBusinessString,
            secondLineNames,
            autoChangeType,
            investigationProceedInfo,
            investigationPauseInfoId,
            investigationPauseInfo,
            investigationPauseReasonId,
            investigationPauseReason,
            investigationPauseReasonRemark,
            investigationTerminationInfo,
            stageNameShow,
            publishStatusStr,
            keyAccountManagerId,
            keyAccountManagerName,
        } = saveParams;
        const { progressInfo, planList, bdUserList, casList, paUserList, pmUserList, pmaList, leaderNameCode } = investigation;
        const isJdeCreate = createType === 'JDE_CREATE';
        const { patientCompleted, patientInProgress, randomAmount } = progressInfo || {};
        const { positionRole, curRole, userId } = sessionStorage;
        
        const iskeyAccountManager = userId == keyAccountManagerId;  //是否为大客户经理
        // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
        let multiplable = true;
        let showStageOther = false;
        if ((investigationByStageId || []).length === 1) {
            const { isMultipleChoice, investigationByStageName } = getMatchOption(byStageList, 'investigationByStageId', investigationByStageId[0]);
            multiplable = isMultipleChoice == 1;
            showStageOther = investigationByStageName === '其他';
        }
        //项目进展显示
        let investigationProceedShow ='';
        (investigationProceedInfo || []).forEach((el,index,arr)=>{
            if(el == null) return
            if(index == arr.length){
                investigationProceedShow = investigationProceedShow+el.typeValue;
            }else{
                investigationProceedShow = investigationProceedShow+el.typeValue+'；';
            }
        }) 

        //业务线为：肿瘤、综合、非肿瘤
        const rulesOfBusiness = lineOfBusinessString == '肿瘤' || lineOfBusinessString == '非肿瘤' || lineOfBusinessString == '综合';
        // 执行业务线二级分类为:非盲
        const rulesSecondLineIsBlind = secondLineNames == '非盲';
        // 执行业务线二级分类为:启动后常规CRC执行、启动前协助+启动后常规CRC执行、其他
        const rulesSecondLineIsStart = secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行' || secondLineNames == '其他'
        //执行业务线二级分类是:遗传办、SSU主导、启动前协助、可行性调研、质量培训、安全事务、小时卡
        const rulesSecondLineIsOther = secondLineNames == '遗传办' || secondLineNames == 'SSU主导' || secondLineNames == '启动前协助' || secondLineNames == '可行性调研' || secondLineNames == '质量培训' || secondLineNames == '安全事务' || secondLineNames == '小时卡';

        const isClinicalPro = isClinicalProject == 1;
        const { typeValue: stageName } = getMatchOption(stageList, 'typeConfigureId', (stageIds || []).slice(-1).join());
        const showAdministrationModeOther = getMatchOption(administrationModeList, 'typeConfigureId', administrationMode).typeValue === '其他';
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', investigation.lineOfBusiness);

        const showSecondLine = (secondLineList || []).length > 0;
        //项目实际结束入组时间必填
        const actualFinishInGroupTimeIsMust = isFinishInGroup == 1 && rulesOfBusiness && ( secondLineNames == '启动前协助+启动后常规CRC执行' || secondLineNames == '启动后常规CRC执行')

        const asterisk = <span style={{ color: "red" }}>*</span>;

        const isBoundBlind =  !!saveParams.blindInvestigationId; 

        const defaultOption = DefaultList.map(d => <Option key={d.value} value={d.value}>{d.label}</Option>);
        const defaultStringOption = DefaultList.map(d => <Option key={String(d.value)} value={String(d.value)}>{d.label}</Option>);
        const levelOption = levelList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        let stageOption = stageList.filter(d => isBoundBlind ? true : (d.operation !== 'INVESTIGATION_DATA_LOCK' && d.operation !== 'INVESTIGATION_LEVEL_LOWEST'))
            .map(d => <Option key={d.typeConfigureId} disabled={d.typeValue === '项目待终止' || d.typeValue === '服务合同签署前终止' || d.typeValue === '业务数据归档'}>{d.typeValue}</Option>);
        const levelIdCanEdit = positionRole == 'BO' || iskeyAccountManager;
        let stageIdCanEdit = true;
        //非盲项目阶段调整
        // if(rulesOfBusiness && rulesSecondLineIsBlind){
        //     stageOption = stageList.filter(el => el.typeValue == '项目执行工作全部完成' || el.typeValue == '项目暂停').map(d => <Option key={d.typeConfigureId}>{d.typeValue}</Option>);
        // }
        if(rulesOfBusiness && rulesSecondLineIsBlind && saveParams.blindInvestigationName){
            stageIdCanEdit = false;
        }
        //启动前，启动前+启动后，其他项目阶段调整
        if(rulesOfBusiness && rulesSecondLineIsStart){
            if(stageNameShow == '项目暂停'){
                stageOption = stageList.map(d => <Option key={d.typeConfigureId} disabled={!(d.typeValue == '准备期' || d.typeValue == '筛选入组期' || d.typeValue == '治疗随访期' || d.typeValue == '治疗结束随访期' || d.typeValue == '数据清理期' || d.typeValue == '自查核查质控期' || d.typeValue == '关闭中心' || d.typeValue == '项目执行工作全部完成')}>{d.typeValue}</Option>);
            }else{
                stageOption = stageList.map(d => <Option key={d.typeConfigureId} disabled={(d.typeValue == '准备期' || d.typeValue == '筛选入组期' || d.typeValue == '治疗随访期' || d.typeValue == '关闭中心' || d.typeValue == '项目待终止' || d.typeValue == '服务合同签署前终止' || d.typeValue == '项目终止' || d.typeValue == '项目关闭' || d.typeValue == '业务数据归档')}>{d.typeValue}</Option>);
            }
        }
        //遗传办&SSU主导&...项目阶段调整
        if(rulesOfBusiness && rulesSecondLineIsOther){
            stageOption = stageList.map(d => <Option key={d.typeConfigureId} disabled={ !(d.typeValue == '准备期' || d.typeValue == '项目执行工作全部完成' || d.typeValue == '项目暂停')}>{d.typeValue}</Option>);
        }
        // const medicineTypeOptions = MedicineTypeList.map(i => <Option key={i.value}>{i.label}</Option>);
        const treatmentMethodOption = treatmentMethodList.map(d => <Option key={d.evaluateTumorTreatMethodId} value={d.evaluateTumorTreatMethodId}>{d.treatMethod}</Option>);
        const administrationModeOption = administrationModeList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const globalTypeOption = GlobalTypeList.map(d => <Option key={d.value}>{d.label}</Option>);
        const testeeTypeOption = testeeTypeList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const businessOption = businessList.map(i => <Option key={String(i.typeConfigureId)} disabled={!(i.groupId == 2)}>{i.typeValue}</Option>);
        const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageId)} disabled={(investigationByStageId || []).length ? multiplable ? d.isMultipleChoice == 0 : d.isMultipleChoice == 1 : false}>{d.investigationByStageName}</Option>);
        const otherCompanyOption = otherCompanyList.map(d => <Option key={d.otherPartnerCompanyId}>{d.otherPartnerCompanyName}</Option>);
        const invPauseInfoOption = invPauseInfo.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const invPauseReasonOption = invPauseReason.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const pmObj = (pmUserList || []).find(d => d.isMain === '1') || {};
        const bigPM = pmObj.userName ?
            pmObj.workStatus == 'LEFT' ?
                <span style={{ color: '#ccc' }}>{pmObj.userName}</span>
                :
                <a onClick={() => this.showUserDetail(pmObj.userId)}>{pmObj.userName}</a>
            :
            '';

        const options = (planList || []).map(item => {
            const { planAmount, planAmountShow, investigationPlanType, investigationPlanName } = item;
            if (!editable) {
                return (
                    <div className="item">
                        {
                            investigationPlanType != "Type_FTE" ?
                                investigationPlanName != '中心' ?
                                    <label className="ui-label">
                                        津石计划{investigationPlanName}数量
                                        </label>
                                    :
                                    <label className="ui-label">津石计划负责中心数量</label>
                                :
                                <label className="ui-label">合同{investigationPlanName}数</label>
                        }
                        {
                            investigationPlanName != 'FTE' && investigationPlanName != '访视' ?
                                <span className="ui-text">{planAmount}</span>
                                :
                                <span className="ui-text">{planAmountShow}</span>
                        }
                    </div>
                )
            } else {
                return (
                    <div className="item">
                        {
                            investigationPlanType != "Type_FTE" ?
                                investigationPlanName != '中心' ?
                                    <label className="ui-label">
                                        {investigationPlanType !== 'Type_Informed' && investigationPlanType != "Type_VisitType" && asterisk}
                                        津石计划{investigationPlanName}数量
                                    </label>
                                    :
                                    <label className="ui-label">{asterisk}津石计划负责中心数量</label>
                                :
                                <label className="ui-label">合同{investigationPlanName}数</label>
                        }
                        {
                            (investigationPlanType != "Type_FTE" && investigationPlanType != "Type_VisitType") ?
                                (
                                    //Type_Informed 知情
                                    //Type_Filter 筛选
                                    //Type_Random 随机(入组)  需求编号：REQ2021051102_smo 中 取消此三个字段的可编辑
                                   (investigationPlanType == 'Type_Informed' || investigationPlanType == 'Type_Filter' || investigationPlanType == 'Type_Random') 
                                    ? (
                                            (investigation.secondLineNames === '非盲' && (curRole == 'PM' || curRole == 'BO' || curRole == 'CTA')) ? 
                                            <InputNumber
                                                style={{ width: 260 }}
                                                placeholder="请输入"
                                                className="ui-text"
                                                onChange={value => this.handleChange(value, `params[${investigationPlanType}]`)}
                                                value={saveParams[`params[${investigationPlanType}]`]}
                                            />
                                            :
                                            <span className="ui-text">{saveParams[`params[${investigationPlanType}]`]}</span>
                                        )
                                    :
                                    <InputNumber
                                        style={{ width: 260 }}
                                        placeholder="请输入"
                                        className="ui-text"
                                        onChange={value => this.handleChange(value, `params[${investigationPlanType}]`)}
                                        value={saveParams[`params[${investigationPlanType}]`]}
                                    />
                                    
                                )
                                :
                                <span className="ui-text">{planAmountShow}</span>
                                // investigationPlanType != "Type_VisitType" ?
                                //     <span className="ui-text">{planAmountShow}</span>
                                //     :
                                //     <span className="ui-text">{planAmount}</span>
                        }
                    </div>
                )
            }
        });

        return (
            <ul className="inv_preview-list">
                <li className="title preview-item"><h4>1.基本信息</h4></li>
                <li className="preview-item">
                    <div className="item" style={{ width: "100%" }}>
                        <label className="ui-label" style={{ width: '20%' }}>{(editable && !isJdeCreate) && asterisk}项目简称</label>
                        <span className="ui-text" style={{ width: '80%' }}>
                            {
                                (editable && !isJdeCreate) ?
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: '100%' }}
                                        value={investigationName}
                                        onChange={e => this.handleChange(e.target.value, 'investigationName')}
                                    />
                                :
                                    this.jointProjectName()
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item" style={{ width: "100%" }}>
                        <label className="ui-label" style={{ width: '20%' }}>项目名称</label>
                        <span className="ui-text" style={{ width: '80%' }}>
                            {
                                editable ?
                                    <TextArea
                                        placeholder="请输入"
                                        style={{ width: '100%' }}
                                        autosize={{ minRows: 2, maxRows: 6 }}
                                        value={saveParams.investigationSpecialName}
                                        onChange={e => this.handleChange(e.target.value, 'investigationSpecialName')}
                                    />
                                :
                                    saveParams.investigationSpecialName
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目识别码</label>
                        <span className="ui-text">
                            {
                                editable ?
                                <SearchRetrieve
                                    keyword='identifyCode'
                                    style={{ width: 260 }}
                                    placeholder="输入名称检索"
                                    value={saveParams.investigationIdentifyCode}
                                    params={{ limit: 20 }}
                                    url={API_URL.contract.queryInvIdentifyCodeList}
                                    config={{ id: 'investigationIdentifyCodeId', name: 'identifyCode' }}
                                    onChange={(option) => this.handleChange(option, 'identifyCode')}
                                />
                                :
                                    saveParams.investigationIdentifyCode
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">临床评估单号</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Select
                                        mode="combobox"
                                        placeholder="输入检索"
                                        style={{ width: 260 }}
                                        filterOption={false}
                                        value={saveParams.evaluateCode}
                                        getInputElement={() => <input autoComplete="off" />}
                                        onFocus={() => this.loadEvaluateCodeOptions(saveParams.evaluateCode)}
                                        onChange={this.handleEvaluateCodeChange}
                                    >
                                        {
                                            (evaluateCodeOptions || []).map(code => (
                                                <Option key={code} value={code}>{code}</Option>
                                            ))
                                        }
                                    </Select>
                                    :
                                    saveParams.evaluateCode
                            }
                        </span>
                    </div>
                </li>
                
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{(editable && !isJdeCreate) && asterisk}项目编号</label>
                        <span className="ui-text">
                            {
                                (editable && !isJdeCreate) ?
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.investigationCode}
                                        onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                                    />
                                :
                                    saveParams.investigationCode
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">CDE登记号</label>
                        <span className="ui-text">
                            {
                                (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.cdeNum}
                                        onChange={e => this.handleChange(e.target.value, 'cdeNum')}
                                    />
                                :
                                    saveParams.cdeNum
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目类型</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        value={saveParams.investigationGlobalType}
                                        onChange={value => this.handleChange(value, 'investigationGlobalType')}
                                    >
                                        {globalTypeOption}
                                    </Select>
                                :
                                    saveParams.investigationGlobalTypeName
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目级别</label>
                        <span className="ui-text">
                            {
                                (editable && levelIdCanEdit) ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.levelId}
                                        onChange={value => this.handleChange(value, 'levelId')}
                                    >
                                        {levelOption}
                                    </Select>
                                :
                                    saveParams.levelName
                            }
                        </span>
                    </div>
                </li>
                <li>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目阶段</label>
                        <span className="ui-text">
                        {
                            editable && stageIdCanEdit ?
                                <Select
                                    mode="multiple"
                                    filterOption={false}
                                    disabled={stageName === '项目终止' || isBoundBlind}
                                    value={stageIds}
                                    style={{ width: 260 }}
                                    onChange={value => this.handleChange(value, 'stageIds')}
                                >
                                    {stageOption}
                                </Select>
                            :
                                saveParams.stageNameShowX
                        }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">此项目是否为临床项目</label>
                        <span className="ui-text">
                            { isClinicalProject != undefined ? isClinicalProject == 1 ? '是' : '否' : '' }
                        </span>
                    </div>
                </li>
                {
                    stageName === '项目待终止' &&
                    <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目终止情况</label>
                                <span className="ui-text">
                                    { investigationTerminationInfo}
                                </span>
                            </div> 
                    </li>
                }{
                    ((stageIds || []).some(el => { return el == '17'}) || 
                    (saveParams.stageNameShowX || '').split(',').some(el => { return el === '数据清理期'}) || 
                    saveParams.investigationPlanLockDate) &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{editable && asterisk}计划锁库日期</label>
                            <span className="ui-text">
                                {   
                                    editable?(
                                        (stageIds || []).some(el => { return el == '17'}) ?
                                        <DatePicker
                                            style={{ width: 260 }}
                                            format={dateFormat}
                                            placeholder="请选择"
                                            value={saveParams.investigationPlanLockDate ? moment(saveParams.investigationPlanLockDate) : null}
                                            defaultValue={saveParams.investigationPlanLockDate ? moment(saveParams.investigationPlanLockDate) : null}
                                            onChange={(date, dateString) => this.handleChange(dateString, 'investigationPlanLockDate')}
                                        />:saveParams.investigationPlanLockDate && moment(saveParams.investigationPlanLockDate).format(dateFormat)
                                    )
                                    :(saveParams.investigationPlanLockDate ? moment(saveParams.investigationPlanLockDate).format(dateFormat) : '')
                                }
                            </span>
                        </div>
                        {
                            saveParams.investigationActualLockDate &&
                            <div className="item">
                            <label className="ui-label">实际锁库日期</label>
                            <span className="ui-text">
                                {
                                    editable ? <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={saveParams.investigationActualLockDate ? moment(saveParams.investigationActualLockDate) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'investigationActualLockDate')}
                                    /> :
                                    moment(saveParams.investigationActualLockDate).format(dateFormat)
                                }
                            </span>
                        </div>   
                        }    
                    </li>
                }
                {
                    stageName === '项目暂停' && editable &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">{editable && asterisk}项目暂停时间</label>
                            <span className="ui-text">
                                    <DatePicker
                                    style={{ width: 260 }}
                                    format={dateFormat}
                                    placeholder="请选择"
                                    disabled={isBoundBlind}
                                    defaultValue={saveParams.suspendTime ? moment(saveParams.suspendTime) : null}
                                    onChange={(date, dateString) => this.handleChange(dateString, 'suspendTime')}
                                />
                            </span>
                        </div>
                    </li>
                }{
                    stageName === '项目暂停'  &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">{editable && asterisk}项目暂停情况</label>
                            <span className="ui-text">
                                {   
                                    editable?
                                        <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.investigationPauseInfoId}
                                        onChange={value => this.handleChange(value, 'investigationPauseInfo')}
                                        onSelect={this.onSelect}
                                    >
                                        {invPauseInfoOption}
                                    </Select>
                                :investigationPauseInfo
                                }
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label clearAfter">{editable && asterisk}项目暂停原因</label>
                            <span className="ui-text">
                                {
                                    editable?
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 260 }}
                                            value={saveParams.investigationPauseReasonId}
                                            onChange={value => this.handleChange(value, 'investigationPauseReason')}
                                            onSelect={this.onSelect}
                                        >
                                            {invPauseReasonOption}
                                        </Select>
                                    :saveParams.investigationPauseReasonId == 136?
                                        investigationPauseReasonRemark?
                                            investigationPauseReason+'（'+investigationPauseReasonRemark+'）':
                                        investigationPauseReason:
                                    investigationPauseReason
                                }
                            </span>
                        </div>
                    </li>
                }
                {
                    stageName === '项目暂停' &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">项目预计恢复日期</label>
                            <span className="ui-text">
                                {
                                    editable?
                                    <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        disabledDate={(current)=>{return current && current.valueOf() < moment().add(-1, 'days')}}
                                        defaultValue={saveParams.investigationEstimatedRecoveryDate ? moment(saveParams.investigationEstimatedRecoveryDate) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'investigationEstimatedRecoveryDate')}
                                    />
                                    :saveParams.investigationEstimatedRecoveryDate?moment(saveParams.investigationEstimatedRecoveryDate).format(dateFormat):null
                                }
                            </span>
                        </div>
                        {   
                            saveParams.investigationPauseReasonId == 136  && editable &&
                            <div className="item">
                                <label style={{width: '40%'}} className="clearAfter"></label>
                                <span className="ui-text">
                                        <Input
                                            maxLength="200"
                                            placeholder="其他说明"
                                            style={{ width: 260 }}
                                            value={investigationPauseReasonRemark}
                                            onChange={e => this.handleChange(e.target.value, 'investigationPauseReasonRemark')}
                                        />
                                </span>
                            </div>
                        }
                    </li>
                }
                {
                    autoChangeType ==='NON_PAUSE' &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">项目暂停日期</label>
                            <span className="ui-text">
                                {
                                    saveParams.investigationPauseDate?
                                    moment(saveParams.investigationPauseDate).format(dateFormat)
                                    :null
                                }
                            </span>
                        </div>
                        <div className="item">
                            <label className="ui-label">项目实际恢复日期</label>
                            <span className="ui-text">
                                {
                                    saveParams.investigationActualRecoveryDate?
                                    moment(saveParams.investigationActualRecoveryDate).format(dateFormat)
                                    :null
                                }
                            </span>
                        </div>
                    </li>
                }
                {
                    autoChangeType ==='NON_PAUSE' &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">暂停周期</label>
                            <span className="ui-text">
                                {saveParams.investigationPauseCycle && saveParams.investigationPauseCycle+'月'}
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目进展</label>
                        <span className="ui-text">
                            { investigationProceedShow}
                        </span>
                    </div> 
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目是否需要过遗传办</label>
                        <span className="ui-text">
                            { 
                                editable ? 
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 260 }}
                                    value={saveParams.investigationNeedHeredity}
                                    onChange={value => this.handleChange(value, 'investigationNeedHeredity')}
                                    onSelect={this.onSelect}
                                >
                                    {defaultStringOption}
                                </Select>:
                                saveParams.investigationNeedHeredity == 1 ? '是' : saveParams.investigationNeedHeredity == 0 ? '否' : ''
                            }
                        </span>
                    </div> 
                </li>
                {
                    !(saveParams.blindType == 'NOTBLIND') && <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目是否结束入组</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.isFinishInGroup || 0}
                                        onChange={value => this.handleChange(value, 'isFinishInGroup')}
                                        onSelect={this.onSelect}
                                    >
                                        {defaultOption}
                                    </Select>
                                :
                                    ((saveParams.stageNames === null || saveParams.stageNames === '') ? '' : (saveParams.isFinishInGroup == 1 ? '是' :  '否'))
                            }
                        </span>
                    </div>
                    {
                        saveParams.isFinishInGroup == 1 && 
                        <div className="item">
                            <label className="ui-label">{editable && actualFinishInGroupTimeIsMust && asterisk}项目实际结束入组时间</label>
                            <span className="ui-text">
                                {
                                    editable ?
                                        <DatePicker
                                            format={dateFormat}
                                            placeholder="请选择"
                                            style={{ width: 260 }}
                                            value={saveParams.actualFinishInGroupTimeShow ? moment(saveParams.actualFinishInGroupTimeShow) : null}
                                            onChange={(date, dateString) => this.handleChange(dateString, 'actualFinishInGroupTimeShow')}
                                        />
                                    :
                                        format('date', saveParams.actualFinishInGroupTimeShow)
                                }
                            </span>
                        </div>
                    }
                </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{Tip} 中心启动情况</label>
                        <span className="ui-text">{saveParams.siteStartStateNumShow}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{(editable && roleAuth.editable_lineOfBusiness) && asterisk}研究产品类型</label>
                        <span className="ui-text">
                            {
                                (editable && roleAuth.editable_lineOfBusiness) ?
                                    <Cascader
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        options={MedicineTypeList}
                                        value={investigationMedicineType}
                                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                                    />
                                :
                                    saveParams.researchProductTypeShow
                            }
                        </span>
                    </div>
                </li>
                {
                    saveParams.lineOfBusinessString === '肿瘤' && (investigationMedicineType[0] === 'Research_drugs' || investigationMedicineType[0] === 'Technology') &&
                    <li className="preview-item">
                        <div className="item">&nbsp;</div>
                        <div className="item">
                            <label className="ui-label">
                                {/* {editable && (saveParams.lineOfBusinessString == '肿瘤' || saveParams.lineOfBusiness == 44) && asterisk} */}
                                肿瘤治疗方式
                            </label>
                            <span className="ui-text">
                                {
                                    (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                        <Select
                                            allowClear={true}
                                            placeholder="请输入检索"
                                            style={{ width: 260 }}
                                            disabled={isBoundBlind}
                                            value={saveParams.treatmentMethod}
                                            showSearch
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={value => this.handleChange(value, 'treatmentMethod')}
                                        >
                                            {treatmentMethodOption}
                                        </Select>
                                    :
                                        saveParams.treatmentMethodShow
                                }
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">&nbsp;</div>
                    <div className="item">
                        <label className="ui-label">药物(疗法)分类/主要作用靶点</label>
                        <span className="ui-text">
                            {       
                                (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                    <SearchMulSelect
                                        keyword='targetName'
                                        className="hospital-multiple"
                                        url={API_URL.evaluate.queryTargetPointsList}
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        searchParam={{ limit: 50 }}
                                        value={saveParams.targetIds || []}
                                        sourceData={TargetPointsOptions}
                                        parseData={this.parseTargetPointsData}
                                        handleSelect={this.targetPointsSelectChange}
                                        placeholder='请输入名称检索'
                                    />
                                :
                                    saveParams.drugMainTargets
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">&nbsp;</div>
                    <div className="item">
                        <label className="ui-label">
                            {investigationMedicineType[0] == 'Research_drugs' ? '研究药物通用名称' : investigationMedicineType[0] == 'Technology' ? '技术名称' : '产品具体名称'}
                        </label>
                        <span className="ui-text">
                            {
                                (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        value={saveParams.investigationMedicine}
                                        onChange={e => this.handleChange(e.target.value, 'investigationMedicine')}
                                    />
                                :
                                    saveParams.investigationMedicine
                            }
                        </span>
                    </div>
                </li>
                {
                    (investigationMedicineType[0] == 'Research_drugs') &&
                    <li className="preview-item">
                        <div className="item">&nbsp;</div>
                        <div className="item">
                            <label className="ui-label">给药方式</label>
                            <span className="ui-text">
                                {
                                    (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                        <Select
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{ width: 260 }}
                                            disabled={isBoundBlind}
                                            value={saveParams.administrationMode }
                                            onChange={value => this.handleChange(value, 'administrationMode')}
                                        >
                                            {administrationModeOption}
                                        </Select>
                                    :
                                        saveParams.administrationModeShow
                                }
                            </span>
                        </div>
                    </li>
                }
                {
                    (investigationMedicineType[0] == 'Research_drugs' && showAdministrationModeOther) &&
                    <li className="preview-item">
                        <div className="item">&nbsp;</div>
                        <div className="item">
                            <label className="ui-label clearAfter">{editable && asterisk}给药方式备注</label>
                            <span className="ui-text">
                                {
                                    (editable && (roleAuth.editable_lineOfBusiness || roleAuth.editable_medicine)) ?
                                        <Input
                                            maxLength="200"
                                            placeholder="请输入"
                                            style={{ width: 260 }}
                                            disabled={isBoundBlind}
                                            value={saveParams.administrationModeRemark}
                                            onChange={e => this.handleChange(e.target.value, 'administrationModeRemark')}
                                        />
                                    :
                                        saveParams.administrationModeRemark
                                }
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{(editable && roleAuth.editable_lineOfBusiness) && asterisk}项目分期</label>
                        <span className="ui-text">
                            {
                                (editable && roleAuth.editable_lineOfBusiness) ?
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        value={saveParams.investigationByStageId}
                                        onChange={value => this.handleChange(value, 'investigationByStageId')}
                                    >
                                        {byStageOption}
                                    </Select>
                                :
                                investigationByStageName
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{(editable && roleAuth.editable_lineOfBusiness) && asterisk}疾病</label>
                        <span className="ui-text">
                            {
                                (editable && roleAuth.editable_lineOfBusiness) ?
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 260 }}
                                        placeholder="输入名称检索"
                                        disabled={isBoundBlind}
                                        value={saveParams.diseaseName}
                                        params={{ limit: 20, investigationMedicineType: investigationMedicineType[0] }}
                                        url={API_URL.common.queryAllDiseaseList}
                                        config={{ id: 'diseaseId', name: 'diseaseName', show: 'disease' }}
                                        onChange={(option) => this.handleChange(option, 'disease')}
                                    />
                                :
                                    saveParams.diseaseName
                            }
                        </span>
                    </div>
                </li>
                {
                    showStageOther &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label clearAfter">其他项目分期备注</label>
                            <span className="ui-text">
                                {
                                    (editable && roleAuth.editable_lineOfBusiness) ?
                                        <Input
                                            maxLength="200"
                                            placeholder="请输入"
                                            style={{ width: 260 }}
                                            disabled={isBoundBlind}
                                            value={investigationByStageRemark}
                                            onChange={e => this.handleChange(e.target.value, 'investigationByStageRemark')}
                                        />
                                    :
                                        investigationByStageRemark
                                }
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">疾病分类</label>
                        <span className="ui-text">{saveParams.diseaseClassName}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">项目领域</label>
                        <span className="ui-text">{saveParams.investigationAreaName}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{(editable && roleAuth.editable_lineOfBusiness) && asterisk}受试者类型</label>
                        <span className="ui-text">
                            {
                                (editable && roleAuth.editable_lineOfBusiness) ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        value={saveParams.testeeTypeId}
                                        onChange={value => this.handleChange(value, 'testeeTypeId')}
                                    >
                                        {testeeTypeOption}
                                    </Select>
                                :
                                    saveParams.testeeTypeName
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{((editable && roleAuth.editable_lineOfBusiness) && !isClinicalPro) && asterisk}业务线</label>
                        <span className="ui-text">
                            {
                                ((editable && roleAuth.editable_lineOfBusiness) && !isClinicalPro) ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        disabled={isClinicalPro}
                                        value={saveParams.lineOfBusiness}
                                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                                    >
                                        {businessOption}
                                    </Select>
                                :
                                    saveParams.lineOfBusinessString
                            }
                        </span>
                    </div>
                </li>
                {
                    showSecondLine &&
                    <li>
                        <div className="item">
                            <label className="ui-label">执行业务线二级分类</label>
                            <span className="ui-text">{investigation.secondLineNames}</span>
                        </div>
                        {
                            investigation.secondLineNames === '非盲' &&
                            <div className="item">
                                <label className="ui-label">配套盲态项目</label>
                                <span className="ui-text">
                                    {
                                        editable ?
                                            <SearchRetrieve
                                                keyword='keyword'
                                                style={{ width: '100%' }}
                                                placeholder="输入名称检索"
                                                disabled={!!investigation.blindInvestigationId}
                                                value={saveParams.blindInvestigationName}
                                                params={{ limit: 20, queryBlindType: 'BLIND' }}
                                                url={API_URL.investigation.queryInvListByParams}
                                                config={{ id: 'investigationId', name: 'investigationName' }}
                                                onChange={option => this.handleConfirmation(option, 'blindInvestigation')}
                                            />
                                        :
                                            saveParams.blindInvestigationName
                                    }
                                </span>
                            </div>
                        }
                        {
                            investigation.secondLineNames === '启动后常规CRC执行'  &&
                            <div className="item">
                                <label className="ui-label">配套启动前项目</label>
                                <span className="ui-text">
                                    {
                                        editable && !canEditBeforeStartInvName ?
                                            <SearchRetrieve
                                                keyword='keyword'
                                                style={{ width: 260 }}
                                                placeholder="输入名称检索"
                                                disabled={!!investigation.blindInvestigationId}
                                                value={saveParams.beforeStartInvName}
                                                params={{ limit: 20 }}
                                                url={API_URL.investigation.queryBeforeStartInv}
                                                config={{ id: 'investigationId', name: 'investigationName' }}
                                                onChange={option => this.handleConfirmation(option, 'beforeStartInv')}
                                            />
                                        :
                                            saveParams.beforeStartInvName
                                    }
                                </span>
                            </div>
                        }
                    </li>
                }
                    <li>
                        {
                            investigation.secondLineNames && isClinicalPro &&
                            <div className="item">
                                <label className="ui-label">项目性质</label>
                                <span className="ui-text">{investigation.invNature}</span>
                            </div>
                        }
                        <div className="item">
                            <label className="ui-label">项目分类</label>
                            <span className="ui-text">{saveParams.investigationTypeName}</span>
                        </div>
                    </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}合同签署方</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='customerCompanyName'
                                        style={{ width: 260 }}
                                        placeholder="输入名称检索"
                                        disabled={isBoundBlind}
                                        value={saveParams.contractSignCompanyName}
                                        params={{ limit: 20 }}
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={option => this.handleChange(option, 'contractSignCompany')}
                                    />
                                :
                                    saveParams.contractSignCompanyName
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}申办方</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='customerCompanyName'
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        placeholder="输入名称检索"
                                        value={saveParams.investigationSponsor}
                                        params={{ limit: 20, natureName: '申办方' }}
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={option => this.handleChange(option, 'sponsor')}
                                    />
                                :
                                    saveParams.investigationSponsor
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">CRO</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='customerCompanyName'
                                        style={{ width: 260 }}
                                        disabled={isBoundBlind}
                                        placeholder="输入名称检索"
                                        value={saveParams.cro}
                                        params={{ limit: 20, natureName: 'CRO' }}
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={option => this.handleChange(option, 'cro')}
                                    />
                                :
                                    saveParams.cro
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">其他合作公司</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={(otherPartnerCompanyList || []).map(i => i.id)}
                                        onChange={value => this.handleChange(value, 'otherPartnerCompanyList')}
                                    >
                                        {otherCompanyOption}
                                    </Select>
                                :
                                   (otherPartnerCompanyList || []).map(i => (
                                       <p key={i.id}>{i.name}{i.value ? `(${i.value})` : null}</p>
                                   ))
                            }
                        </span>
                    </div>
                </li>
                {
                    (editable && (otherPartnerCompanyList || []).length > 0) &&
                    otherPartnerCompanyList.map((item, index) => (
                        <li className="preview-item" key={item.id}>
                            <div className="item">&nbsp;</div>
                            <div className="item">
                                <label className="ui-label">{item.name}</label>
                                <span className="ui-text">
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={item.value}
                                        onChange={e => this.handleOCCTextChange(e.target.value, index)}
                                    />
                                </span>
                            </div>
                        </li>
                    ))
                }
                <li>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目计划开始时间</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <DatePicker
                                        format={dateFormat}
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.investigationPlanBeginTime ? moment(saveParams.investigationPlanBeginTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'investigationPlanBeginTime')}
                                    />
                                :
                                    format('date', saveParams.investigationPlanBeginTime)
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}项目计划结束时间</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <DatePicker
                                        format={dateFormat}
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.investigationPlanEndTime ? moment(saveParams.investigationPlanEndTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'investigationPlanEndTime')}
                                    />
                                :
                                    format('date', saveParams.investigationPlanEndTime)
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">计收入确认方式</label>
                        <span className="ui-text">{saveParams.contractTypeName} </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">合同额含税/人民币</label>
                        <span className="ui-text">{saveParams.investigationContractAmountStr || 0} 元</span>
                    </div>
                </li>
                <li className="preview-item">
                    {options[5]}
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}合同计划中心数量</label>
                        <span className="ui-text">
                            {
                                (editable && (canEditContractSitePlanAmount || saveParams.lineOfBusinessString === 'ARO' || saveParams.lineOfBusinessString === '招募')) ?
                                    <InputNumber
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.contractSitePlanAmount}
                                        onChange={value => this.handleChange(value, 'contractSitePlanAmount')}
                                    />
                                :
                                    saveParams.contractSitePlanAmount
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">合同计划知情数量</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <InputNumber
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.contractInformedPlanAmount}
                                        onChange={value => this.handleChange(value, 'contractInformedPlanAmount')}
                                    />
                                :
                                    saveParams.contractInformedPlanAmount
                            }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}合同计划筛选数量</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <InputNumber
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.contractFilterPlanAmount}
                                        onChange={value => this.handleChange(value, 'contractFilterPlanAmount')}
                                    />
                                :
                                    saveParams.contractFilterPlanAmount
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{editable && asterisk}合同计划随机(入组)数量</label>
                        <span className="ui-text">
                            {
                                (editable && (canEditContractRandomPlanAmount || saveParams.lineOfBusinessString === 'ARO' || saveParams.lineOfBusinessString === '招募')) ?
                                    <InputNumber
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.contractRandomPlanAmount}
                                        onChange={value => this.handleChange(value, 'contractRandomPlanAmount')}
                                    />
                                :
                                    saveParams.contractRandomPlanAmount
                            }
                        </span>
                    </div>
                    {options[0]}
                </li>
                <li className="preview-item">
                <div className="item">
                        <label className="ui-label">合同计划标准访视数</label>
                        <span className="ui-text">{saveParams.contractStandardAmount}</span>
                    </div>
                </li>
                <li className="preview-item">
                    {options[1]}
                    {options[2]}
                </li>
                <li className="preview-item">
                    {options[3]}
                    {options[4]}
                </li>
                <li className="preview-item">
                    {saveParams.firstSiteStartTimeFlag &&
                        <div className="item">
                            <label className="ui-label">{editable && asterisk}津石第一家研究中心启动计&nbsp;&nbsp;&nbsp;&nbsp;<br />划开始时间</label>
                            <span className="ui-text">
                                {
                                    (editable && saveParams.firstSiteStartTimeUpdateFlag) ? <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={saveParams.firstSiteStartTime ? moment(saveParams.firstSiteStartTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'firstSiteStartTime')}
                                        disabledDate={this.disabledDate}
                                    /> :
                                    (saveParams.firstSiteStartTime ? moment(saveParams.firstSiteStartTime).format(dateFormat) : '')
                                }
                            </span>
                        </div>
                    }
                    {saveParams.oneHundredPercentSiteStartTimeFlag &&
                        <div className="item">
                            <label className="ui-label">{editable && asterisk}津石100%中心启动计划开始&nbsp;&nbsp;&nbsp;&nbsp;<br />时间</label>
                            <span className="ui-text">
                                {
                                    (editable && saveParams.oneHundredPercentSiteStartTimeUpdateFlag) ? <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={saveParams.oneHundredPercentSiteStartTime ? moment(saveParams.oneHundredPercentSiteStartTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'oneHundredPercentSiteStartTime')}
                                        disabledDate={this.disabledDate}
                                    /> :
                                    (saveParams.oneHundredPercentSiteStartTime ? moment(saveParams.oneHundredPercentSiteStartTime).format(dateFormat) : '')
                                }
                            </span>
                        </div>
                    }
                </li>
                <li className="preview-item">
                    {saveParams.firstPatientGroupStartTimeFlag &&
                        <div className="item">
                            <label className="ui-label">{editable && asterisk}津石首例受试者随机&nbsp;&nbsp;&nbsp;&nbsp;<br />（入组）计划开始时间</label>
                            <span className="ui-text">
                                {
                                    (editable && saveParams.firstPatientGroupStartTimeUpdateFlag) ? <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={saveParams.firstPatientGroupStartTime ? moment(saveParams.firstPatientGroupStartTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'firstPatientGroupStartTime')}
                                        // disabledDate={this.disabledDate}
                                    /> :
                                    (saveParams.firstPatientGroupStartTime ? moment(saveParams.firstPatientGroupStartTime).format(dateFormat) : '')
                                }
                            </span>
                        </div>
                    }
                    {saveParams.oneHundredPercentGroupStartTimeFlag &&
                        <div className="item">
                            <label className="ui-label">{editable && asterisk}津石100%受试者随机&nbsp;&nbsp;&nbsp;&nbsp;<br />（入组）计划开始时间</label>
                            <span className="ui-text">
                                {
                                    (editable && saveParams.oneHundredPercentGroupStartTimeUpdateFlag) ? <DatePicker
                                        style={{ width: 260 }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={saveParams.oneHundredPercentGroupStartTime ? moment(saveParams.oneHundredPercentGroupStartTime) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'oneHundredPercentGroupStartTime')}
                                        // disabledDate={this.disabledDate}
                                    /> :
                                    (saveParams.oneHundredPercentGroupStartTime ? moment(saveParams.oneHundredPercentGroupStartTime).format(dateFormat) : '')
                                }
                            </span>
                        </div>
                    }
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">津石计划标准访视数</label>
                        <span className="ui-text">{saveParams.standardVisitAmount}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">是否为对垒项目</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 260 }}
                                        value={saveParams.isAgainstInvestigation}
                                        onChange={value => this.handleChange(value, 'isAgainstInvestigation')}
                                    >
                                        {defaultOption}
                                    </Select>
                                :
                                    saveParams.isAgainstInvestigation == 1 ? '是' : saveParams.isAgainstInvestigation == 0 ? '否' : ''
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">访视周期计划是否已发布</label>
                        <span className="ui-text">
                            { publishStatusStr }
                        </span>
                    </div>
                    <div className="item">
                        <label className="ui-label">研究亮点</label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <Input
                                        placeholder="请输入"
                                        style={{ width: 260 }}
                                        value={saveParams.highlights}
                                        onChange={e => this.handleChange(e.target.value, 'highlights')}
                                    />
                                :
                                    saveParams.highlights
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">研究周期</label>
                        <span className="ui-text">
                            {
                                saveParams.researchCycle != null
                                    ? <a onClick={this.openResearchCycleModal}>{saveParams.researchCycle}</a>
                                    : ''
                            }
                        </span>
                    </div>
                    <div className="item">&nbsp;</div>
                </li>
                <li className="title preview-item"><h4>2.项目进展部分</h4></li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">合同FTE数</label>
                        <span className="ui-text">{processData.planFte}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">预估FTE数</label>
                        <span className="ui-text">{processData.estimateFte}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计消耗FTE数</label>
                        <span className="ui-text">{processData.cumulativeConsumptionFte}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">项目当月累计完工百分比</label>
                        <span className="ui-text">{processData.cumulativeFinishPersent}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计开票进度百分比</label>
                        <span className="ui-text">{processData.accumulateInvoiceProgressPercentShow}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">累计回款进度百分比</label>
                        <span className="ui-text">{processData.accumulateBackProgressPercentShow}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计开票进度和完工进度&nbsp;&nbsp;&nbsp;&nbsp;<br />金额差异（不含税）</label>
                        <span className="ui-text">{processData.accumulateInvoiceFinishDeviation}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">累计回款进度和完工进度&nbsp;&nbsp;&nbsp;&nbsp;<br />金额差异（不含税）</label>
                        <span className="ui-text">{processData.accumulateBackFinishDeviation}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目当月合同&初始计划</label>
                        <span className="ui-text">{processData.contractInitialPlan}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">项目当月累计进度动态参考值</label>
                        <span className="ui-text">{processData.accumulativeProgress}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">津石计划负责中心数&nbsp;&nbsp;&nbsp;&nbsp;<br />vs实际启动中心数</label>
                        <span className="ui-text">{processData.investigationSitePlanToSiteStart}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">计划知情数vs累计知情数</label>
                        <span className="ui-text">{processData.planInformed2Informed}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">计划筛选数&nbsp;&nbsp;&nbsp;&nbsp;<br />vs累计筛选数</label>
                        <span className="ui-text">{processData.planFilter2Filter}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">计划随机(入组)数&nbsp;&nbsp;&nbsp;&nbsp;<br />vs累计随机(入组)数</label>
                        <span className="ui-text">{processData.planRandom2Random}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">津石计划访视数vs累计完成&nbsp;&nbsp;&nbsp;&nbsp;<br />访视数(计划内+计划外)</label>
                        <span className="ui-text">{processData.investigationVisitPlanToCompleted}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">津石计划标准访视数vs累计完&nbsp;&nbsp;&nbsp;&nbsp;<br />成标准访视数(计划内+计划外)</label>
                        <span className="ui-text">{processData.planStandardVisit2StandardVisit}</span>
                    </div>


                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">当月确认标准访视数</label>
                        <span className="ui-text">{processData.monthStandardVisit}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">累计退出数</label>
                        <span className="ui-text">{processData.dropCount}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计方案违背数</label>
                        <span className="ui-text">{processData.violationCount}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">累计重大事件数</label>
                        <span className="ui-text">{processData.majorEventCount}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计SAE数</label>
                        <span className="ui-text">{processData.saeCount}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">津石当前管理的在组病例数</label>
                        <span className="ui-text">{patientInProgress || 0}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">津石累计完成研究病例数</label>
                        <span className="ui-text">{patientCompleted || 0}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">津石当月新入组病例数</label>
                        <span className="ui-text">{randomAmount || 0}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">月启动速率</label>
                        <span className="ui-text">{saveParams.monthBeginSpeed}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">平均启动时长</label>
                        <span className="ui-text">{saveParams.avgBeginDay}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">入组周速率</label>
                        <span className="ui-text">{saveParams.weekGroupSpeed}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">入组月速率</label>
                        <span className="ui-text">{saveParams.monthGroupSpeed}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">累计回款金额/人民币</label>
                        <span className="ui-text">{processData.receivingAmount}</span>
                    </div>
                </li>
                <li className="title preview-item"><h4>3.项目负责人</h4></li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">大项目经理</label>
                        <span className="ui-text">{bigPM}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">项目经理</label>
                        <span className="ui-text">{this.getUserByWorkStatus(pmUserList)}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">项目管理员</label>
                        <span className="ui-text">{this.getUserByWorkStatus(paUserList)}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">协助项目成员</label>
                        <span className="ui-text">{this.getUserByWorkStatus(pmaList)}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">BD</label>
                        <span className="ui-text">{this.getUserByWorkStatus(bdUserList)}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">CSA</label>
                        <span className="ui-text">{this.getUserByWorkStatus(casList)}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">领域leader</label>
                        <span className="ui-text">{this.getUser(leaderNameCode)}</span>
                    </div>
                    <div className="item">
                        <label className="ui-label">大客户经理</label>
                        <span className="ui-text">{this.getKeyAccountManager(keyAccountManagerId,keyAccountManagerName)}</span>
                    </div>
                </li>
            </ul>
        );
    }

    //研究周期明细弹框（数据来源：临床评估）
    renderResearchCycleModal = () => {
        const { researchCycleModalVisible, researchCycleEditable, researchCycleSaving, evaluateCycleParams, saveParams, editable } = this.state;
        //两个一行
        const cycleRows = [];
        for (let i = 0; i < CycleList.length; i += 2) {
            cycleRows.push(CycleList.slice(i, i + 2));
        }
        //父页面处于编辑态时弹框直接为编辑态，仅保留确认按钮
        let footer = null;
        if (editable) {
            footer = [
                <Button key="save" type="primary" loading={researchCycleSaving} onClick={this.saveEvaluateCycleInfo}>确认</Button>
            ];
        }
        return (
            <Modal
                title="研究周期"
                visible={researchCycleModalVisible}
                onCancel={this.closeResearchCycleModal}
                footer={footer}
            >
                <ul className="inv_preview-list">
                    {
                        cycleRows.map((row, rowIndex) => (
                            <li key={rowIndex}>
                                {
                                    row.map(field => (
                                        <div className="item" key={field.key}>
                                            <label className="ui-label">{field.label}</label>
                                            <span className="ui-text">
                                                {
                                                    researchCycleEditable
                                                        ? <InputNumber
                                                            style={{ width: '100%' }}
                                                            placeholder="请输入"
                                                            value={evaluateCycleParams[field.key]}
                                                            onChange={value => this.handleCycleChange(value, field.key)}
                                                        />
                                                        : (saveParams[field.key] != null ? saveParams[field.key] : '')
                                                }
                                            </span>
                                        </div>
                                    ))
                                }
                            </li>
                        ))
                    }
                </ul>
            </Modal>
        );
    }

    //关闭研究周期明细弹框
    closeResearchCycleModal = () => {
        this.setState({
            researchCycleModalVisible: false,
            researchCycleEditable: false,
        });
    }

    //研究周期明细弹框-打开（父页面编辑态时弹框直接为编辑态）
    openResearchCycleModal = () => {
        const { editable, saveParams } = this.state;
        if (!editable) {
            this.setState({ researchCycleModalVisible: true });
            return;
        }
        this.setState({
            evaluateCycleParams: {
                preparePeriod: saveParams.preparePeriod,
                joinGroupPeriod: saveParams.joinGroupPeriod,
                treatmentPeriod: saveParams.treatmentPeriod,
                followUpPeriod: saveParams.followUpPeriod,
                survivalFollowUpPeriod: saveParams.survivalFollowUpPeriod,
                dbl: saveParams.dbl,
                closeSite: saveParams.closeSite,
            },
            researchCycleEditable: true,
            researchCycleModalVisible: true,
        });
    }

    //研究周期明细弹框-编辑值变化
    handleCycleChange = (value, key) => {
        const { evaluateCycleParams } = this.state;
        this.setState({
            evaluateCycleParams: { ...evaluateCycleParams, [key]: value },
        });
    }

    //研究周期 = 准备期+入组期+治疗期+随访期+生存随访期+DBL+关中心（空值跳过，保留两位小数，与后端计算逻辑一致）
    calculateResearchCycle = params => {
        let sum = null;
        ['preparePeriod', 'joinGroupPeriod', 'treatmentPeriod', 'followUpPeriod', 'survivalFollowUpPeriod', 'dbl', 'closeSite'].forEach(key => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                sum = sum === null ? Number(value) : sum + Number(value);
            }
        });
        return sum === null ? null : Math.round(sum * 100) / 100;
    }

    //研究周期明细弹框-保存
    saveEvaluateCycleInfo = () => {
        const { investigationId, evaluateCycleParams } = this.state;
        //校验：已填写的明细必须是大于等于0的数值
        for (let i = 0; i < CycleList.length; i++) {
            const { label, key } = CycleList[i];
            const value = evaluateCycleParams[key];
            if (value !== null && value !== undefined && value !== '' && Number(value) < 0) {
                message.warning(`${label}必须是大于等于0的数值，请重新输入`);
                return;
            }
        }
        this.setState({ researchCycleSaving: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.saveEvaluateCycleInfo,
            data: {
                investigationId,
                ...evaluateCycleParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { saveParams } = this.state;
                //同步父页面显示：7项明细 + 后端相同规则计算出的研究周期
                this.setState({
                    saveParams: {
                        ...saveParams,
                        ...evaluateCycleParams,
                        researchCycle: this.calculateResearchCycle(evaluateCycleParams),
                    },
                    researchCycleSaving: false,
                    researchCycleEditable: false,
                    researchCycleModalVisible: false,
                });
                message.success('保存成功');
            },
            errorResult: () => {
                this.setState({ researchCycleSaving: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const {
            editable,
            visible,
            loading,
            processLoading,
            dictLoading,
            saveParams,
        } = this.state;
        const { isModal, canEdit = true } = this.props;
        const { userId } = sessionStorage;
        const { keyAccountManagerId } = saveParams;
        const iskeyAccountManager = userId == keyAccountManagerId;
        let footer = <Button type="ghost" onClick={this.cancel}>关闭</Button>;
        if (canEdit && (roleAuth.editable || iskeyAccountManager)) {
            if (editable) {
                footer = [
                    <Button type='primary' loading={loading || processLoading} onClick={this.save}>保存</Button>,
                    <Button type="ghost" onClick={this.cancel}>取消</Button>
                ];
            } else {
                footer = <Button disabled={loading} type="primary" onClick={this.canEditByInvStatus}><Icon type="edit" />编辑</Button>;
            }
        }
        if (isModal) {
            return (
                <Modal
                    title="查看项目信息和进展"
                    visible={visible}
                    onCancel={this.cancel}
                    className="preview-modal"
                    width="1000px"
                    maskClosable={false}
                    bodyStyle={{ maxHeight: 500 }}
                    footer={footer}
                >
                    <Spin spinning={loading || processLoading || dictLoading}>
                        <div className="cont-cont">
                            {this.getContent()}
                            <UserDetail ref={el => this.userDetailRef = el} />
                            {this.renderResearchCycleModal()}
                        </div>
                    </Spin>
                </Modal>
            );
        } else {
            return (
                <Spin spinning={loading || processLoading || dictLoading}>
                    <div className="cont-cont">
                        {
                            canEdit &&
                            <div style={{ marginBottom: 20, textAlign: 'right' }}>
                                <Button type="primary" disabled={loading} onClick={this.canEditByInvStatus}><Icon type="edit" />编辑</Button>
                            </div>
                        }
                        <p style={{ marginBottom: 10, paddingLeft: 10, color: '#F00' }}>请根据实际项目情况，调整项目计划开始时间、项目计划结束时间</p>
                        {this.getContent()}
                        {
                            editable &&
                            <div style={{ marginTop: 20, textAlign: 'center' }}>
                                <Button type='primary' loading={loading || processLoading}  onClick={this.save} style={{ marginRight: 15 }}>保存</Button>
                                <Button type='primary' onClick={this.cancel}>取消</Button>
                            </div>
                        }
                        <UserDetail ref={el => this.userDetailRef = el} />
                        {this.renderResearchCycleModal()}
                    </div>
                </Spin>
            )
        }
    }
}

export default ViewInfoProcess;



// WEBPACK FOOTER //
// ./src/components/investigation/ViewInfoProcess.js